import { Reducers } from '@sda/enums/store';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Payout } from '@sda/interfaces/payout';

/**
 * SDK Class to interact the PrivateShows subcollection Payouts
 */
export class Payouts extends SDK<Payout> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.PAYOUTS);

    this.collection = this.fsh.Schema.PrivatePayouts;
  }
}
